import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';

import { catchError, filter, take, switchMap, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

import { NbToastrService } from '@nebular/theme';

import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { Token } from '../model/token.model';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null );
  static lastRequet: string = '';
  constructor(public authService: AuthService, 
    private router: Router, 
    private toastService: NbToastrService,
    protected $gaService: GoogleAnalyticsService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<Object>> {
    let authReq = req;
    const token = this.authService.getJwtToken();
    if (token != null) {
      authReq = this.addTokenHeader(req, token);
    }
    return next.handle(authReq).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && !authReq.url.includes('auth/login') && error.status === 401) {
        return this.handle401Error(authReq, next);
      }
      return throwError(error);
    }));
  }
  
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.refreshTokenSubject.next(null);
      const token = this.authService.getRefreshToken();
      if (token) {
        this.isRefreshing = true;
        return this.authService.refreshToken(token).pipe(
          switchMap((tokens: Token) => {
            this.authService.storeJwtToken(tokens.jwt);
            this.authService.storeRefreshToken(tokens.refreshToken);
            this.refreshTokenSubject.next(tokens.jwt);
            
            console.log('>>> RefreshToken: updating');
            console.log(`    JWT: ${tokens.jwt}`);
            console.log(`    RefreshToken: ${tokens.refreshToken}`);
            return next.handle(this.addTokenHeader(request, tokens.jwt));
          }),
          catchError((err) => {
            this.authService.doLogoutUser();
            
            console.log('>>> RefreshToken: error');
            console.log(`    Error: ${err}`);
            return throwError(err);
          }),
          finalize(() => {
            console.log('>>> RefreshToken: finalize');
            this.isRefreshing = false; 
          })
        );
      }
      else if (!this.router.url.includes('login') && !this.router.url.includes('lobby-panel') && this.router.navigated) {
        console.log('>>> RefreshToken: not found, redirecting to login');
        this.authService.doLogoutUser();
      }
    }
    return this.refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((token) => next.handle(this.addTokenHeader(request, token)))
    );
  }
  
  private addTokenHeader(request: HttpRequest<any>, token: string) {
    return request.clone({ headers: request.headers.set('Authorization', `Bearer ${token}`) });
  }
}
